import { formatResponse } from '../utils/FormatUtils/formatResponse';
import { api } from './Api';

// Import loadImage utility from UploadService to process media URLs
const loadImage = (url) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    xhr.onprogress = () => {};

    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response;
        resolve(blob);
      } else {
        reject(new Error(`Request failed with status ${xhr.status}`));
      }
    };

    xhr.onerror = () => {
      reject(new Error('Network error occurred'));
    };
    xhr.send();
  });

export const getMenuItems = async ({ restId }) => {
  const response = await api.get(`/restmanager/${restId}/menus`);
  const formattedResponse = formatResponse({
    data: response,
    type: 'items',
  });
  return formattedResponse;
};

export const getItem = async ({ restId, menuId, id }) => {
  const response = await api.get(
    `/restmanager/${restId}/menus/${menuId}/items/${id}`
  );

  // Process media URLs like lam-portal does - convert to blob URLs
  if (response?.media && response.media.length > 0) {
    for (const mediaItem of response.media) {
      if (mediaItem.url) {
        try {
          // Add protocol if missing and create blob URL
          const imageUrl = mediaItem.url.startsWith('//')
            ? `https:${mediaItem.url}?width=200&height=200`
            : `${mediaItem.url}?width=200&height=200`;

          const blob = await loadImage(imageUrl);
          mediaItem.url = URL.createObjectURL(blob);
        } catch (error) {
          // Fallback to original URL if blob conversion fails
          console.warn('Failed to convert media URL to blob:', error);
          if (mediaItem.url.startsWith('//')) {
            mediaItem.url = `https:${mediaItem.url}`;
          }
        }
      }
    }
  }

  const formattedResponse = formatResponse({
    data: { ...response },
    type: 'item',
  });
  return formattedResponse;
};

export const cloneItem = async ({ restId, menuId, id }) => {
  const response = await api.put(
    `/restmanager/${restId}/menus/${menuId}/items/${id}`
  );
  const formattedResponse = formatResponse({
    data: { ...response },
    type: 'item',
  });
  return formattedResponse;
};

export const deleteItem = async ({
  restId,
  menuId,
  id,
  start,
  end,
  permanent,
}) => {
  const response = await api.delete(
    `/restmanager/${restId}/menus/${menuId}/items/${id}`,
    {
      ...(start && { start }),
      ...(end && { end }),
      ...(permanent && { permanent }),
    }
  );
  return response;
};

export const saveItem = async ({ restId, menuId, id, item }) => {
  const {
    media,
    prices,
    description,
    name,
    category,
    service,
    preparation,
    type,
    meta_category,
    sort,
  } = item;
  await api.post(`/restmanager/${restId}/menus/${menuId}/items/${id}`, {
    description,
    sort,
    preparation,
    type,
    name,
    meta_category,
    category,
    price: prices.takeout.base,
    service,
    media: media?.length !== 0 ? media : {},
  });
  const formattedResponse = formatResponse({
    data: { ...item },
    type: 'item',
  });
  return formattedResponse;
};

export const saveCategory = async ({ restId, id, category }) => {
  const { name, sort } = category;

  await api.post(`/restmanager/${restId}/categories/${id}`, {
    sort,
    name,
  });
};

export const makeItemAvailable = async ({ restId, menuId, id, item }) => {
  await api.put(`/restmanager/${restId}/menus/${menuId}/items/${id}/restore`);
  const formattedResponse = formatResponse({
    data: { ...item, status: 'active', available: true },
    type: 'item',
  });
  return formattedResponse;
};
